/**
 * Shared response parsing for PUT section_separation (Brazil and other sources with the same shape).
 */
import { SectionSeparationSaveResult } from '../components/Common/SectionSeparation/types';
import { resolveSimpleSaveResponse } from './resolveSimpleSaveResponse';

// eslint-disable-next-line import/prefer-default-export
export const resolveSectionSeparationSaveResponse = (response: any): SectionSeparationSaveResult =>
  resolveSimpleSaveResponse(
    response,
    'Successfully submitted the file',
    'Failed to submit section separation'
  );
